import {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";

import {clientRpRequestMeta} from "../../../client/client_rp_request_meta";
import {IRPStore} from "../../app/rp_reducer";
import {fetchUserRecommendationsStateAction} from "../actions/fetch_user_recommendations_state_action";
import {useIsAuthenticated} from "./use_is_authenticated";

export const useUserRecommendationState = () => {
    const dispatch = useDispatch();
    const isAuthenticated = useIsAuthenticated();
    const recommendationsStateStats = useSelector((state: IRPStore) => state.user.recommendationsState.data?.stats);

    useEffect(() => {
        if (isAuthenticated && !recommendationsStateStats) {
            dispatch(fetchUserRecommendationsStateAction({meta: clientRpRequestMeta}));
        }
    }, [isAuthenticated, recommendationsStateStats]);

    return {
        recommendationsStateStats,
        recommendedCount:
            (recommendationsStateStats?.not_seen_count &&
                recommendationsStateStats?.sold_not_seen_count &&
                recommendationsStateStats.not_seen_count - recommendationsStateStats.sold_not_seen_count) ||
            0
    };
};
import {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";

import {clientRpRequestMeta} from "../../../client/client_rp_request_meta";
import {IRPStore} from "../../app/rp_reducer";
import {fetchUserRecommendationsStateAction} from "../actions/fetch_user_recommendations_state_action";
import {useIsAuthenticated} from "./use_is_authenticated";

export const useUserRecommendationState = () => {
    const dispatch = useDispatch();
    const isAuthenticated = useIsAuthenticated();
    const recommendationsStateStats = useSelector((state: IRPStore) => state.user.recommendationsState.data?.stats);

    useEffect(() => {
        if (isAuthenticated && !recommendationsStateStats) {
            dispatch(fetchUserRecommendationsStateAction({meta: clientRpRequestMeta}));
        }
    }, [isAuthenticated, recommendationsStateStats]);

    return {
        recommendationsStateStats,
        recommendedCount:
            (recommendationsStateStats?.not_seen_count &&
                recommendationsStateStats?.sold_not_seen_count &&
                recommendationsStateStats.not_seen_count - recommendationsStateStats.sold_not_seen_count) ||
            0
    };
};
